import './switchWithInput.scss'
import templateUrl from './switchWithInput.html'

/**
 * Switch-with-input component.
 *
 * A switch that has an editable label only when it's on.
 *
 * @example
 * <tmr-switch-with-input
 *   label="SOME.TRANSLATION.KEY"
 *   force-focus=""
 *   is-on=""
 *   is-disabled=""
 *   on-value=""
 *   on-change=""
 * ></tmr-switch-with-input>
 *
 * @type {ngComponent}
 */
export const tmrSwitchWithInput = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrSwitchWithInputController',
  bindings: {
    label: '@',
    forceFocus: '<?',
    isOn: '<',
    isDisabled: '<',
    onValue: '<',
    onChange: '&',
    onKeyPress: '&',
  },
}

/**
 * Controller of component {@link tmrSwitchWithInput}.
 *
 * @type {ngController}
 */
export class tmrSwitchWithInputController {
  static ngType = 'controller'

  change() {
    this.onChange({ isOn: this.isOn, onValue: '' })
    this.justChanged = true
  }
}
